import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { ErrorMessages } from '@shared/interfaces/errorMesagges.interface';

@Component({
  selector: 'soph-input-search-form-field',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatInputModule
  ],
  templateUrl: './input-search-form-field.component.html',
  styleUrl: './input-search-form-field.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InputSearchFormFieldComponent {
  @Input() control: FormControl = new FormControl();
  @Input() placeholder: string = 'Buscar...';
  @Input() label: string = '';
  @Input() errorMessages: ErrorMessages = {};

  get hasError() {
    return this.control?.touched && this.control?.invalid;
  }

  get errorMessage() {
    if (!this.control) return '';
    const errors = this.control.errors;
    if (errors) {
      for (const error of Object.keys(errors) as (keyof ErrorMessages)[]) {
        if (errors[error]) {
          return this.errorMessages[error] || '';
        }
      }
    }
    return '';
  }
}
